export default require('../otherChains/injective').default.rpcUrls.default.http[0]